import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import axios from "axios";
import banner from "../banner.png";
import { FaEnvelope, FaKey } from 'react-icons/fa'; // Import icons

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const apiUrl = process.env.REACT_APP_API_URL || 'https://sharedvision-partners.online/v1/API/login.php'; // Use environment variable for API URL

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      setErrorMessage('Please enter both email/phone and password.');
      return;
    }

    setIsLoading(true);
    try {
      const response = await axios.post(apiUrl, { email, password });
      setIsLoading(false);

      if (response.data.success) {
        const user = response.data.user;

        // Check if the role is user before storing and redirecting
        if (user.role === 'user') {
          localStorage.setItem('user', JSON.stringify(user)); // Store user data in localStorage
          navigate('/dashboard'); // Redirect to user dashboard
        } else {
          setErrorMessage('Access denied: You must be a user to access this page.');
        }
      } else {
        setErrorMessage(response.data.message || 'Invalid credentials or user not found. Please sign up.');
      }
    } catch (error) {
      setIsLoading(false);
      if (error.response) {
        setErrorMessage(`Error: ${error.response.data.message || 'An error occurred while logging in. Please try again.'}`);
      } else {
        setErrorMessage('Network error. Please check your internet connection.');
      }
    }
  };

  // Define const styles here
  const containerStyle = {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "transparent",
  };

  const formContainerStyle = {
    backgroundColor: "#fff",
    borderRadius: "15px",
    boxShadow: "1 8px 16px rgba(0, 0, 0, 0.1)",
    padding: "30px",
    width: "100%",
    maxWidth: "400px",
    textAlign: "center",
  };

  const inputGroupStyle = {
    border: "1px solid #ccc",
    borderRadius: "10px",
    padding: "8px 15px",
    marginBottom: "20px",
  };

  const buttonStyle = {
    backgroundColor: "#007bff",
    borderRadius: "10px",
    padding: "12px",
    border: "none",
    fontSize: "16px",
    transition: "background-color 0.3s ease",
    width: "100%",
  };

  const buttonHoverStyle = {
    backgroundColor: "#0056b3",
  };

  const transparentbg = {
    backgroundColor: "transparent",
    border: "none", // Removes any borders
    outline: "none", // Removes any outlines
    

    
  };
  
  
  

  return (
    <div style={containerStyle}>
      <div className="row w-100">
        <div className="col-md-6 p-4 d-flex justify-content-center align-items-center">
          <div className="text-center">
            <img src="/logo.png" alt="Logo" style={{ width: "150px", marginBottom: "5px" }} />
            <p className="text-muted mb-4">Welcome to SharedVision Partners! Login to access your account.</p>
            <div className="d-none d-md-block ">
              <img src={banner} alt="banner" className="img-fluid" style={{ maxWidth: "550px" }} />
            </div>
          </div>
        </div>

        <div className="col-md-6 d-flex flex-column justify-content-center align-items-center p-4">
          <div style={formContainerStyle}>
            <h2 className="mb-4">Login</h2>
            <Form onSubmit={handleSubmit}>
              <Form.Group controlId="Email" className="mb-4">
                <div className="input-group mb-3" style={inputGroupStyle}>
                <span className="input-group-text" style={{ border: '0',background: 'transparent' }}>
    <FaEnvelope className="fa-fw" style={transparentbg} />
  </span>
                  <Form.Control
                    type="email"
                    placeholder="Enter email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="form-control"
                    aria-label="Email"
                    style={{ borderRadius: "10px" }}
                  />
                </div>
              </Form.Group>

              <Form.Group controlId="formPassword" className="mb-4">
                <div className="input-group mb-3" style={inputGroupStyle}>
                <span className="input-group-text" style={{ border: '0',background: 'transparent' }}>
                    <FaKey className="fa-fw" />
                  </span>
                  <Form.Control
                    type="password"
                    name="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter your password"
                    className="form-control"
                    aria-label="Password"
                    style={{ borderRadius: "10px" }}
                  />
                </div>
              </Form.Group>

              {errorMessage && (
                <div className="alert alert-danger mb-4" role="alert">
                  {errorMessage}
                </div>
              )}

              <Button
                type="submit"
                disabled={isLoading}
                variant="primary"
                style={buttonStyle}
                onMouseEnter={(e) => (e.target.style.backgroundColor = buttonHoverStyle.backgroundColor)}
                onMouseLeave={(e) => (e.target.style.backgroundColor = buttonStyle.backgroundColor)}
              >
                {isLoading ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : 'Login'}
                {isLoading && ' Logging in...'}
              </Button>
            </Form>

            <div className="text-center mt-3">
              <p>
                <a href="/forgetPass" className="text-primary">Forgot Password?</a>
              </p>
              <span className="text-muted">Don't have an account? </span>
              <a href="/register" className="text-primary">Sign Up</a>
            </div>
            <p> <a href="/admin" className="text-primary">Web</a></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
